import { PRODUCT_IDENTITIES, productForLocation, reservationOptionsProduct } from './productIdentity';

// Only a server-confirmed canonical slug can form a customer URL. Never normalize
// names or cached account fields here: a guessed slug can name another tenant.
export function canonicalPublicPath(moduleId, slug) {
  const prefixes = { beclick: '/c/', beresa: '/reservation/', customer_chatbot: '/chat/' };
  const prefix = Object.hasOwn(prefixes, moduleId) ? prefixes[moduleId] : null;
  return prefix && typeof slug === 'string' && slug.length <= 200 && /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(slug)
    ? `${prefix}${slug}` : null;
}
export function moduleShortcutLinks(module, product, publicSlug) {
  if (module?.enabled !== true || !Object.hasOwn(PRODUCT_IDENTITIES, product)) return [];
  const actions = {
    beclick: [{ label: 'Gérer le catalogue', to: `/admin/dashboard?tab=Produits&product=${product}` }],
    beresa: [{ label: 'Gérer les réservations', to: `/caisse/reservations?product=${product}&from=options` }],
    customer_chatbot: [{ label: 'Configurer l’Assistant menu', to: `/admin/dashboard?tab=Chatbot&product=${product}` }],
  };
  const links = Object.hasOwn(actions, module.id) ? actions[module.id] : [];
  const publicPath = canonicalPublicPath(module.id, publicSlug);
  return publicPath ? [...links, { label: 'Voir la page client', to: publicPath, public: true }] : links;
}
export function reservationOptionsContext(input) {
  const location = typeof input === 'string' ? { pathname: '/caisse/reservations', search: input } : input;
  const product = reservationOptionsProduct(location);
  return product ? { product, name: PRODUCT_IDENTITIES[productForLocation(location)].name, returnPath: `/admin/options?product=${product}` } : null;
}
